module.exports = __webpack_public_path__ + "img/home-jump4.54dd0c93.png";